import axios from 'axios';
import Cookie from 'cookies-js';
import toastr from 'toastr';
import config from '../../../config/index';
import routes from '../../../constants/routes';
import {
  MT_LIP_INVESTMENT,
  MT_LIP_INVESTMENT_ERROR,
  MT_LIP_INVESTMENT_LOADING,
  MT_LIP_INVESTMENT_ERROR_DELETE
} from '../../types';

const mtLipInvestmentSuccess = mtLip => ({
  type: MT_LIP_INVESTMENT,
  mtLip
});

const mtLipInvestmentLoading = () => ({
  type: MT_LIP_INVESTMENT_LOADING
});

const mtLipInvestmentError = error => ({
  type: MT_LIP_INVESTMENT_ERROR,
  error
});

export const deleteMtLipInvestmentError = () => ({
  type: MT_LIP_INVESTMENT_ERROR_DELETE
});

const mtLipInvestment = mtLipDetails => (dispatch) => {
  dispatch(mtLipInvestmentLoading());
  const token = Cookie.get('jwtToken');
  return axios.post(`${config.apiUrl}${routes.MTLIPINVESTMENT}`, mtLipDetails, {
    headers: { Authorization: `Bearer ${token}` }
  }).then((response) => {
    dispatch(mtLipInvestmentLoading());
    const { data } = response;
    if (data.isSuccessful) {
      dispatch(mtLipInvestmentSuccess(data));
      toastr.success('Hurray! Your MT Lip Investment was successful.');
    } else {
      dispatch(mtLipInvestmentError(data.responseMessage));
    }
  }).catch((error) => {
    const { data } = error.response;
    dispatch(mtLipInvestmentLoading());
    dispatch(mtLipInvestmentError(data.responseMessage));
    throw error;
  });
};

export default mtLipInvestment;
